import { useEffect } from 'react';
import { documentTitle } from '../config/branding';
import { publishBreadcrumbLeaf } from '../components/workspace/breadcrumbLeaf';

export default function useDocumentTitle(titleSuffix, options = {}) {
  const publishLeaf = options.leaf !== false;
  useEffect(() => {
    document.title = documentTitle(titleSuffix);
    if (!publishLeaf) return undefined;
    publishBreadcrumbLeaf(titleSuffix || '');
    return () => publishBreadcrumbLeaf('');
  }, [titleSuffix, publishLeaf]);
}
